import { GTMAnalytics } from '~services/analytics';
import { updateRegistrationMarkersAsync } from '~shared/api/origin/analytics/registration';
import {
	DatadogLogger,
	LoggerMessages,
	LoggerServices,
} from '~shared/services/logger';

export const updateUserRegistrationInfo = async ({
	data,
	userId,
}: {
	data: Record<string, string>;
	userId: string;
}): Promise<void> => {
	try {
		GTMAnalytics.annalsRegistrationPromise = Promise.resolve(data);
		await updateRegistrationMarkersAsync({ userId, data });
	} catch (error) {
		DatadogLogger.error(
			LoggerServices.AnnalsService,
			LoggerMessages.AnnalsSentRegistrationEventError,
			{}
		);
	}
};
